module.exports = __webpack_public_path__ + "static/media/gu.a71909cf.png";